import { useEffect, useState } from 'react'
import { apiEtapa3 } from '../api'
import Aviso from '../../components/Aviso'
import { competenciaAtual } from '../../components/format'
import { Campo, dataBR } from '../../etapa2/componentes'

const VAZIO = { cnpj: '', cnae_preponderante: '', classificacao_tributaria: '99', empresa_inscrita_pat: false }
const SITUACAO = { ALERTA: 'Vence em menos de 48h', VENCIDO: 'Prazo vencido', NO_PRAZO: 'No prazo' }

function Ocorrencias({ resultado }) {
  return (
    <div className={`aviso aviso-${resultado.valido ? 'ok' : 'erro'}`}>
      <strong>{resultado.evento}: {resultado.valido ? 'válido' : 'bloqueado'}</strong>
      {resultado.ocorrencias.length > 0 && (
        <ul>{resultado.ocorrencias.map((o, i) => <li key={i}>[{o.severidade === 'IMPEDITIVO' ? 'impeditivo' : 'alerta'}] {o.mensagem}</li>)}</ul>
      )}
    </div>
  )
}

export default function ESocial({ empresaId }) {
  const [cad, setCad] = useState(VAZIO)
  const [salvo, setSalvo] = useState(null)
  const [painel, setPainel] = useState(null)
  const [sincronizacoes, setSincronizacoes] = useState([])
  const [s1210, setS1210] = useState({ funcionario_id: 'F1', cpf_beneficiario: '', competencia: competenciaAtual(), data_pagamento: '', valor_liquido: '' })
  const [payload, setPayload] = useState(null)
  const [erro, setErro] = useState('')
  const [ok, setOk] = useState('')

  async function carregar() {
    if (!empresaId) return
    try {
      const c = await apiEtapa3.cadastro(empresaId)
      setSalvo(c)
      setCad(Object.fromEntries(Object.keys(VAZIO).map((k) => [k, c[k]])))
    } catch {
      setSalvo(null)
      setCad(VAZIO)
    }
    apiEtapa3.painel(empresaId).then(setPainel).catch((e) => setErro(e.message))
    apiEtapa3.sincronizacoes().then(setSincronizacoes).catch(() => {})
  }
  useEffect(() => { carregar() }, [empresaId])

  async function executar(acao, mensagem) {
    setErro('')
    setOk('')
    try {
      const r = await acao()
      if (mensagem) setOk(typeof mensagem === 'function' ? mensagem(r) : mensagem)
      await carregar()
      return r
    } catch (e) {
      setErro(e.message)
    }
  }

  const set = (k) => (e) => setCad({ ...cad, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value })
  const salvar = () => executar(() => apiEtapa3.salvarCadastro(empresaId, cad), 'Cadastro salvo.')
  const consultarFap = () =>
    executar(() => apiEtapa3.consultarFap(salvo.cnpj), (r) => `FAP ${r.ano}: ${r.fator_fap}. RAT ajustado: ${r.aliquota_rat_ajustado ?? 'empresa sem parametrização'}.`)
  async function gerarS1210() {
    setPayload(null)
    const r = await executar(() => apiEtapa3.gerarS1210({ ...s1210, empresa_id: empresaId }), 'S-1210 gerado.')
    if (r) setPayload(r.payload)
  }
  const enviado = (id) => executar(() => apiEtapa3.marcarEnviado(id), 'Evento marcado como enviado.')

  return (
    <section>
      <h2>eSocial</h2>
      <Aviso>{erro}</Aviso>
      <Aviso tipo="ok">{ok}</Aviso>

      <h3>Painel de alertas</h3>
      {painel && (
        <>
          {painel.cadastro.map((r) => <Ocorrencias key={r.evento} resultado={r} />)}
          {painel.s2299.length === 0 && <p className="fundamento">Nenhum S-2299 pendente.</p>}
          {painel.s2299.length > 0 && (
            <table>
              <thead><tr><th>S-2299</th><th>Desligamento</th><th>Prazo</th><th>Situação</th><th /></tr></thead>
              <tbody>
                {painel.s2299.map((e) => (
                  <tr key={e.evento_id} className={e.situacao === 'NO_PRAZO' ? '' : 'alerta-linha'}>
                    <td>{e.funcionario_id}</td>
                    <td>{dataBR(e.data_desligamento)}</td>
                    <td>{new Date(e.prazo).toLocaleString('pt-BR')}</td>
                    <td>{SITUACAO[e.situacao]}{e.situacao !== 'VENCIDO' && ` (${e.horas_restantes}h)`}</td>
                    <td><button className="link" onClick={() => enviado(e.evento_id)}>marcar enviado</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {painel.lotes_s1200_bloqueados.length > 0 && (
            <div className="aviso aviso-erro">
              <strong>Lotes S-1200 bloqueados</strong>
              <ul>
                {painel.lotes_s1200_bloqueados.map((l) => (
                  <li key={l.lote_id}>{l.competencia}: {l.ocorrencias.map((o) => o.mensagem).join(' · ')}</li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}

      <h3>Cadastro do estabelecimento (S-1000 / S-1005)</h3>
      <div className="grade">
        <Campo rotulo="CNPJ"><input value={cad.cnpj} onChange={set('cnpj')} /></Campo>
        <Campo rotulo="CNAE preponderante"><input value={cad.cnae_preponderante} onChange={set('cnae_preponderante')} placeholder="6201501" /></Campo>
        <Campo rotulo="Classificação tributária (S-1000)"><input value={cad.classificacao_tributaria} onChange={set('classificacao_tributaria')} maxLength="2" /></Campo>
        <label className="check"><input type="checkbox" checked={cad.empresa_inscrita_pat} onChange={set('empresa_inscrita_pat')} />Empresa inscrita no PAT</label>
      </div>
      {salvo?.cnpj_anterior && <p className="fundamento">CNPJ alterado (anterior: {salvo.cnpj_anterior}). Consulte o FAP do novo CNPJ.</p>}
      {salvo?.fap_consultado && (
        <p className="fundamento">Último FAP consultado: {salvo.fap_consultado.valor} ({salvo.fap_consultado.ano}, CNPJ {salvo.fap_consultado.cnpj})</p>
      )}
      <div className="acoes">
        <button disabled={!empresaId} onClick={salvar}>Salvar cadastro</button>
        <button className="secundario" disabled={!salvo} onClick={consultarFap}>Consultar FAP no Serpro</button>
      </div>

      <h3>S-1210: pagamento de rendimentos</h3>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={s1210.funcionario_id} onChange={(e) => setS1210({ ...s1210, funcionario_id: e.target.value })} /></Campo>
        <Campo rotulo="CPF"><input value={s1210.cpf_beneficiario} onChange={(e) => setS1210({ ...s1210, cpf_beneficiario: e.target.value })} /></Campo>
        <Campo rotulo="Período de apuração"><input type="month" value={s1210.competencia} onChange={(e) => setS1210({ ...s1210, competencia: e.target.value })} /></Campo>
        <Campo rotulo="Data real do pagamento"><input type="date" value={s1210.data_pagamento} onChange={(e) => setS1210({ ...s1210, data_pagamento: e.target.value })} /></Campo>
        <Campo rotulo="Valor líquido pago"><input type="number" step="0.01" value={s1210.valor_liquido} onChange={(e) => setS1210({ ...s1210, valor_liquido: e.target.value })} /></Campo>
      </div>
      <div className="acoes"><button disabled={!empresaId} onClick={gerarS1210}>Gerar S-1210</button></div>
      {payload && <pre className="memoria payload">{JSON.stringify(payload, null, 2)}</pre>}

      <h3>Sincronização de tabelas fiscais</h3>
      <p className="fundamento">Roda todo dia às 02:00. A execução manual exige a chave administrativa e é feita pelo backend.</p>
      {sincronizacoes.length === 0 ? <p className="fundamento">Nenhuma sincronização registrada.</p> : (
        <table>
          <thead><tr><th>Data</th><th>Origem</th><th>Status</th><th>Detalhe</th></tr></thead>
          <tbody>
            {sincronizacoes.map((s) => (
              <tr key={s.sincronizacao_id}>
                <td>{new Date(s.iniciado_em).toLocaleString('pt-BR')}</td><td>{s.origem}</td><td>{s.status}</td>
                <td>{s.versao_publicada || (s.erros || []).join('; ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  )
}
